import React, { useEffect, useState } from "react";
import TopNavbar from "../topNavbar/TopNavbar";
import Sidebar from "../sidebar/Sidebar";
import { Card, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Button from "react-bootstrap/Button";
import * as icons from "react-bootstrap-icons";
import { Footer } from "../../Footer";
import {
  PlayerGetById,
  WebAdminProfile,
  ManagerGetById,
  GetSubScription,
} from "../../redux/auth-reducer/auth-service";
// SP-11: import { ImageUrl, ZIP_LOOKUP_URL } from "../../utils/config/config";
import { ImageUrl } from "../../utils/config/config";
import { useZipLookup, ZIP_LENGTH } from "../../utils/hooks/useZipLookup";
import { useImageUpload } from "../../hooks/useImageUpload";
import { IMAGE_ACCEPT, IMAGE_HINT, IMAGE_STILL_UPLOADING } from "../../utils/helper/imageUpload";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import { DatePicker, Loader } from "rsuite";
import flags from "react-phone-number-input/flags";
// #108: the phone field shows the stored digits as they are - see formattedNumber below.
// import { parsePhoneNumberFromString } from "libphonenumber-js";
import {
  isSubscriptionActive as isServerSubscriptionActive,
  pickCurrentSubscription,
} from "../../utils/helper/helper";
import { announceBellChanged } from "../../utils/helper/notifications";
import { NAME_PATTERN } from "../../utils/helper/names";
import {
  EMAIL_REQUIRED,
  PHONE_INVALID,
  ZIP_INVALID,
  isUnderAdultAge,
  latestAdultBirthDate,
  personNameError,
  requiredError,
} from "../../utils/helper/validation";
import { COUNTRY_CODE_ERROR, isCountryCallingCode } from "../../utils/helper/phone";

// #108: the API has no "empty" for a date of birth. AdminUser.DateOfBirth is nullable, but the
// result model's DateOfBirth is a plain DateTime, so a profile that never had one arrives as
// 0001-01-01T00:00:00 - which the picker rendered as "Jan 01,0001" and every "is it filled in"
// check accepted. Anything in 1900 or earlier is that sentinel, not a birthday.
//
// #227: 1900 itself too - the mobile app's date picker starts at 1900-01-01 and can save that
// instead. The server (usp_InsertUserProfile, fn_PlayerSystemNotifications) applies the same rule,
// so the web and the bell's "Fill in your personal data" agree on what is missing.
const isRealDateOfBirth = (value) => {
  if (!value) return false;
  const date = new Date(value);
  return !Number.isNaN(date.getTime()) && date.getFullYear() > 1900;
};

// The phone field's defaultCountry (US): what it shows until the player picks another.
const US_CALLING_CODE = 1;

// #108: the profile as the form needs it. A null gender left the select uncontrolled, a null
// image never matched the `=== ""` checks, and the sentinel date above passed as filled in - so
// none of the three could ever be reported as missing.
//
// #227: the zip code is stored as a number, so 02134 comes back as 2134 - shown that way it failed
// the field's own five-digit pattern, and the profile could not be saved again without retyping it.
// It is padded back to five digits; 0 and null are no zip code at all.
const normalizeProfile = (data) => ({
  ...data,
  dateOfBirth: isRealDateOfBirth(data?.dateOfBirth) ? data.dateOfBirth : "",
  gender: data?.gender ?? "",
  userImage: data?.userImage ?? "",
  phoneNumber: String(data?.phoneNumber ?? "").replace(/\D/g, ""),
  zipCode: data?.zipCode ? String(data.zipCode).padStart(ZIP_LENGTH, "0") : "",
});

export const Profile = () => {
  const [data, setData] = useState(false);
  const [loading, setLoading] = useState(true);
  // The picture Save sends and the page shows. See useImageUpload for what a failed upload does: Save
  // used to send the old picture while an upload was still on its way, and a slow reply for an
  // earlier pick could replace a later one.
  const picture = useImageUpload();
  const { reset: resetPicture } = picture;
  const [validated, setValidated] = useState(false);
  const [userData, setUserData] = useState();
  const [countryIDName, setCountryIDName] = useState("");
  const [stateIDName, setStateIDName] = useState("");
  const [cityIDName, setCityIDName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [inputDate, setInputDate] = useState();
  const [dateBirth, setDateBirth] = useState();
  const [dataSubscription, setDataSubscription] = useState();

  const [regForm, setRegForm] = useState({
    userImage: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    phoneNumber: "",
    countryCode: "",
    emailId: "",
    address: "",
    country: "",
    state: "",
    city: "",
    zipCode: "",
  });

  const navigate = useNavigate();

  // Toggle sidebar state
  function sidebarfun() {
    setData(!data);
  }

  // Dedicated loading state for profile data
  useEffect(() => {
    const isRole = localStorage.getItem("role");
    const isUser = JSON.parse(localStorage.getItem("isUser"));
    const userId = isUser?.userId;

    const fetchUserData = async () => {
      try {
        if (
          isRole === "Web Admin" ||
          isRole === "Manager" ||
          isRole === "Admin"
        ) {
          const res = await ManagerGetById();
          setUserData(res?.data?.userImage);
          setCountryIDName(res?.data?.country);
          setStateIDName(res?.data?.state);
          setCityIDName(res?.data?.city);
          setRegForm(normalizeProfile(res?.data));
          resetPicture(res?.data?.userImage);
        } else if (isRole === "Player") {
          const res = await PlayerGetById(userId);
          setUserData(res?.data?.userImage);
          setCountryIDName(res?.data?.country);
          setStateIDName(res?.data?.state);
          setCityIDName(res?.data?.city);
          setRegForm(normalizeProfile(res?.data));
          resetPicture(res?.data?.userImage);
        }
      } catch (error) {
        toast.error("Failed to load profile data");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [resetPicture]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    // Save would otherwise send the picture the field had, not the one still on its way.
    if (picture.uploading) {
      toast.error(IMAGE_STILL_UPLOADING);
      return;
    }

    setValidated(true);

    // #108: one pass over every field, and nothing is sent until all of them pass. This used to
    // stop at the first custom check (an alert for the date, a toast for the image) and otherwise
    // never asked the browser at all - so an invalid form went to the server, whose 400 came back
    // looking like a success and switched the highlighting off again.
    //
    // if (regForm?.dateOfBirth === "") {
    //   alert("Date of Birth is required.");
    //   return;
    // }
    //
    // if (regForm?.userImage === "") {
    //   toast.error("Please upload an image.");
    //   return;
    // }
    //
    // checkValidity covers the native fields: names, gender, phone, address, country/state/city
    // and the zip code. The date picker is not a native input the browser can check, so it is
    // tested here and its message is rendered from the same condition.
    //
    // #227: the photo is optional. It was required here alone - the API and the mobile app never
    // asked for one - so a player could not complete their profile without uploading a picture.
    const nativeValid = form.checkValidity();
    const dateOfBirthMissing = !regForm?.dateOfBirth;
    if (!nativeValid || dateOfBirthMissing || zipError || countryCodeInvalid) {
      return;
    }

    try {
      const dataList = [
        {
          // #227: null, not "", when there is no photo: TopNavbar and the mobile app treat any
          // stored value as an image file name.
          userImage: picture.name || null,
          firstName: regForm?.firstName,
          lastName: regForm?.lastName,
          DateOfBirth: regForm.dateOfBirth,
          gender: regForm.gender,
          phoneNumber: regForm.phoneNumber,
          emailId: userData?.emailId,
          address: regForm.address,
          // #227: the code the field shows. Until the player picks a country it shows its
          // defaultCountry, US (+1), but regForm.countryCode stayed empty and the profile was
          // saved with country code 0 - which counts as missing, so "Fill in your personal data"
          // never went away.
          countryCode: Number(regForm.countryCode) || US_CALLING_CODE,
          country: location?.country || countryIDName,
          state: location?.["places"]?.[0]?.state || stateIDName,
          city: location?.["places"]?.[0]?.["place name"] || cityIDName,
          // #227: a number, as Organization.js sends it - the field holds "02134", and the API's
          // ZipCode is an int.
          zipCode: Number(regForm.zipCode) || null,
          isPlayer: false,
        },
      ];

      const res = await WebAdminProfile(dataList);
      // #108: strictly `true`. A rejected request hands back the server's error body, and an
      // ASP.NET validation error carries `status: 400` - truthy - so `if (res?.status)` treated it
      // as a save, cleared every highlighted field and showed an empty success toast.
      if (res?.status === true) {
        setValidated(false);
        toast.success(res?.message, { toastId: "success12" });
        // Now update localStorage so that TopNavbar reflects the updated name/image
        const isUser = JSON.parse(localStorage.getItem("isUser"));
        const updatedUser = {
          ...isUser,
          fullName: `${regForm.firstName} ${regForm.lastName}`,
          // The picture just saved: the same value the request sent.
          userImage: picture.name || null,
        };
        localStorage.setItem("isUser", JSON.stringify(updatedUser));
        // #227: "Fill in your personal data" on the bell may be over now.
        announceBellChanged();
      } else {
        toast.error(
          res?.message || res?.title || "Could not update your profile.",
          { toastId: "error12" }
        );
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const isUserLocal = JSON.parse(localStorage.getItem("isUser"));
  const isRole = localStorage.getItem("role");

  // #108: follows the field both ways - an emptied date must empty the picker too, not leave it
  // showing the last value.
  useEffect(() => {
    setDateBirth(regForm?.dateOfBirth ? new Date(regForm.dateOfBirth) : null);
  }, [regForm?.dateOfBirth]);

  const handelGender = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value,
    });
  };

  const handelform = (e) => {
    let value = e.target.value;
    if (e.target.name === 'firstName' || e.target.name === 'lastName') {
      // value = value.replace(/[^a-zA-Z\s]/g, '').slice(0, 30);
      value = value.slice(0, 30);
    }
    // #108: handleKeypress only filters typing - a paste still lands here with spaces, dashes or
    // brackets, which the 10-digit pattern (and the procedure) would then reject.
    if (e.target.name === 'phoneNumber') {
      value = value.replace(/\D/g, '');
    }
    setRegForm({
      ...regForm,
      [e.target.name]: value,
    });
  };

  const handelPhone = (e) => {
    setRegForm({
      ...regForm,
      phoneNumber: e,
    });
  };

  const handelDate = (e) => {
    // #108: the picker's clear button calls this with null, and `new Date(null)` is the epoch -
    // clearing the field set the date of birth to 1970-01-01 instead of leaving it empty.
    setRegForm({
      ...regForm,
      dateOfBirth: e ? new Date(e).toISOString().slice(0, 19) : "",
    });
    setInputDate(e);
  };

  // #227: and nothing in 1900 or earlier, which the server refuses as no date at all.
  const shouldDisableDate = (date) => {
    return date.getFullYear() <= 1900 || isUnderAdultAge(date);
  };

  const cancelbtn = () => {
    navigate(-1);
  };

  const handleKeypress = (e) => {
    const characterCode = e.key;
    if (characterCode === "Backspace") return;
    const characterNumber = Number(characterCode);
    if (characterNumber >= 0 && characterNumber <= 9) {
      if (!e.currentTarget.value || e.currentTarget.value.length === 0) {
        if (characterNumber === 0) {
          e.preventDefault();
        }
      }
    } else {
      e.preventDefault();
    }
  };

  // SP-11: the lookup moves to the shared hook - it has a time limit, it cancels a superseded
  // request, and `zipError` is RENDERED below the postcode field. The old version set an error
  // into state that nothing read, so a slow or failing service left three empty fields and no
  // explanation on screen.
  // const [location, setLocation] = useState(null);
  // const [error, setError] = useState("");
  const {
    location,
    error: zipError,
    loading: zipLoading,
    lookup: lookupZip,
    reset: resetZip,
  } = useZipLookup();

  const handelZipCode = async (e) => {
    const zipCode = e.target.value;
    setRegForm({
      ...regForm,
      [e.target.name]: zipCode,
    });

    // SP-11: clear a stale result and any stale message as soon as the field stops being a
    // complete postcode, so the country/state/city shown always belong to what is typed.
    if (zipCode.length === ZIP_LENGTH) {
      await lookupZip(zipCode);
    } else {
      resetZip();
    }
  };

  // const handelZipCode = async (e) => {
  //   const zipCode = e.target.value;
  //   setRegForm({ ...regForm, [e.target.name]: zipCode });
  //   if (zipCode.length === 5) {
  //     try {
  //       const response = await fetch(`${ZIP_LOOKUP_URL}${zipCode}`);
  //       if (!response.ok) {
  //         throw new Error("Zip code not found");
  //       }
  //       const data = await response.json();
  //       setLocation(data);
  //       setError("");
  //     } catch (err) {
  //       setError(err.message);
  //       setLocation(null);
  //     }
  //   }
  // };

  useEffect(() => {
    if (regForm.countryCode) {
      setCountryCode(`+${regForm.countryCode}`);
    }
  }, [regForm.countryCode]);

  const handelPhoneCountryCode = (e) => {
    // #250: undefined when the picker has no code; it used to be stored as "+undefined".
    const newCountryCode = e ? e.replace("+", "") : "";
    setCountryCode(newCountryCode ? `+${newCountryCode}` : "");
    setRegForm((prevForm) => ({
      ...prevForm,
      countryCode: newCountryCode,
    }));
  };

  // #250: digits typed into the code box ("+1" -> "+199") make a code no country has; it used to
  // be saved without a word. Nothing picked is the +1 the picker shows (US_CALLING_CODE below).
  const countryCodeInvalid = !isCountryCallingCode(countryCode);

  // #108: the field is validated against pattern="[1-9]{1}[0-9]{9}" - ten bare digits, the same
  // rule usp_InsertUserProfile enforces - so showing "(201) 555-0123" here made every correctly
  // stored number fail its own field's validation. It also could not be edited: maxLength 10 is
  // already exceeded by the formatted 14 characters.
  // const phoneNumber = parsePhoneNumberFromString(
  //   String(regForm?.phoneNumber),
  //   "US"
  // );
  // const formattedNumber = phoneNumber
  //   ? phoneNumber.formatNational()
  //   : regForm?.phoneNumber;

  useEffect(() => {
    const GetBySubscriptionFn = async () => {
      setLoading(true);
      try {
        const response = await GetSubScription();
        const data = response?.data?.data;

        if (data && data.length > 0) {
          setLoading(false);
          // Taking the last entry raw was a second, divergent copy of the "which subscription is
          // current" rule. It happens to agree with the shared helper today only because the
          // procedure's ORDER BY sorts the Stripe row last - one ordering change away from
          // showing a user their old grant instead of their live subscription.
          setDataSubscription(pickCurrentSubscription(data));
        }
      } catch (error) {
        console.error("Error fetching subscription data:", error);
      }
    };

    GetBySubscriptionFn();
  }, []);

  // Determine subscription status.
  //
  // This was the last place still comparing the end date in the browser. A failed renewal revokes
  // access while the end date stays in the future - deliberately, because shortening it would
  // deactivate the account - so a date comparison reported a blocked user as active. The server
  // flag is the only thing that can see the difference.
  const isSubscriptionActive = () => {
    if (isRole !== "Player") {
      return true; // Bypass subscription check for non-Player roles
    }

    return isServerSubscriptionActive(dataSubscription);
  };

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />
      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Profile</h1>
            </Col>
            <Col md={6} className="text-right">
              {loading ? (
                ""
              ) : isRole === "Player" ? (
                isSubscriptionActive() ? (
                  <Button href="/Player/Account_settings" variant="success">
                    Active
                  </Button>
                ) : (
                  <Button href="/Player/Account_settings" variant="danger">
                    Inactive
                  </Button>
                )
              ) : null}
            </Col>
          </Row>
          <Card className="p-5 profile-sec">
            {loading ? (
              <Loader />
            ) : (
              <Form
                noValidate
                validated={validated}
                onSubmit={handleSubmit}
                onKeyPress={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
              >
                <Row>
                  <Col md={4} lg="4">
                    <div className="text-center editprofileimage">
                      <div>
                        {/* The picture Save will send, not the file picked: an upload that failed
                            leaves the current one. */}
                        {picture.name ? (
                          <img src={ImageUrl + picture.name} alt="profile" />
                        ) : (
                          <img
                            src="../image/profileDefault.png"
                            alt="default profile"
                          />
                        )}
                        <label
                          htmlFor="file"
                          className="editprofileicon"
                          name="file"
                          onChange={(event) => picture.upload(event.target)}
                        >
                          <icons.Pencil />
                          {/* #108: no `required` - a file input is empty on every visit, even
                              when the profile already has an image, so it made the form
                              natively invalid for everyone. #227: and the photo is optional. */}
                          <Form.Control
                            type="file"
                            id="file"
                            multiple=""
                            accept={IMAGE_ACCEPT}
                            data-original-title="upload photos"
                          />
                        </label>
                      </div>
                      <p className="mt-2 image-upload-mess">
                        {/* #227: no required mark - the photo is optional. #308: the one hint
                            every image field shows. */}
                        {IMAGE_HINT}
                      </p>
                    </div>
                  </Col>
                  <Col md={7} className="border-custom profile-form-sec">
                    <Row className="mb-3">
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        controlId="validationCustom02"
                      >
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                          onChange={handelform}
                          name="firstName"
                          value={regForm?.firstName}
                          required
                          // #253: letters, spaces, apostrophes and hyphens, as the API checks.
                          pattern={NAME_PATTERN}
                          maxLength="30"
                          type="text"
                          placeholder="Enter your first name"
                          onKeyPress={(e) => {
                            if (e.key === "Enter") e.preventDefault();
                          }}
                        />
                        <Form.Control.Feedback type="invalid">
                          {personNameError("first name", regForm?.firstName)}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        controlId="validationCustomUsername"
                      >
                        <Form.Label>Last Name</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="lastName"
                            maxLength="30"
                            value={regForm?.lastName}
                            placeholder="Enter your last name"
                            aria-describedby="inputGroupPrepend"
                            // #253: optional, so an empty value passes; anything typed follows
                            // the rule. It used to take any text and get the green tick.
                            pattern={NAME_PATTERN}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") e.preventDefault();
                            }}
                          />
                          <Form.Control.Feedback type="invalid">
                            {personNameError("last name", regForm?.lastName)}
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        controlId="formDateOfBirth"
                      >
                        <Form.Label>Date of Birth</Form.Label>
                        <DatePicker
                          placeholder="Select Date of Birth"
                          shouldDisableDate={shouldDisableDate}
                          // #293: an empty field opens on the latest allowed birthday, not on
                          // this month, where every day is disabled.
                          calendarDefaultDate={latestAdultBirthDate()}
                          format="MMM dd,yyyy"
                          value={dateBirth}
                          name="dateOfBirth"
                          className={
                            validated && !regForm?.dateOfBirth
                              ? "Auction-Date is-invalid"
                              : "Auction-Date"
                          }
                          onChange={handelDate}
                          required
                        />
                        {/* #108: rsuite puts `required` on its wrapper div, not the input, so the
                            browser never validates this field and no :invalid sibling rule can
                            reveal the message - and Feedback has no `show` prop. Rendered from
                            the same condition handleSubmit uses instead. */}
                        {validated && !regForm?.dateOfBirth && (
                          <Form.Control.Feedback type="invalid" className="d-block">
                            {requiredError("date of birth")}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3" className="text-left">
                        <Form.Label>Gender</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Select
                            onChange={handelGender}
                            name="gender"
                            value={regForm?.gender}
                            className="select-option"
                            required
                            as="select"
                          >
                            <option value={""}>Select Gender</option>
                            <option value={"M"}>Male</option>
                            <option value={"F"}>Female</option>
                            <option value={"O"}>Other</option>
                          </Form.Select>
                          <Form.Control.Feedback type="invalid">
                            Please select your gender.
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3">
                        <Form.Label>Phone Number</Form.Label>
                        <div className="d-flex flex-wrap group-ph">
                          <PhoneInput
                            type="text"
                            international
                            // undefined, not "": the picker resets an empty string to
                            // defaultCountry and would hide that no country is chosen.
                            value={countryCode || undefined}
                            onChange={handelPhoneCountryCode}
                            flags={flags}
                            defaultCountry="US"
                            countryCallingCodeEditable={false}
                          />
                          <Form.Control
                            type="text"
                            maxLength="10"
                            onKeyDown={handleKeypress}
                            className="phone-number-input"
                            pattern="[1-9]{1}[0-9]{9}"
                            onChange={handelform}
                            name="phoneNumber"
                            value={regForm?.phoneNumber}
                            placeholder="Enter your phone number"
                            required
                          />
                          {/* #108: must be the input's sibling - Bootstrap reveals it with
                              `:invalid ~ .invalid-feedback`, which never matched from outside
                              .group-ph. w-100 plus flex-wrap on .group-ph put it on its own line
                              under the input. */}
                          <Form.Control.Feedback type="invalid" className="w-100">
                            {PHONE_INVALID}
                          </Form.Control.Feedback>
                        </div>
                        {validated && countryCodeInvalid && (
                          <Form.Control.Feedback type="invalid" className="d-block">
                            {COUNTRY_CODE_ERROR}
                          </Form.Control.Feedback>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3">
                        <Form.Label>Email/User Id</Form.Label>
                        <Form.Control
                          type="email"
                          value={regForm?.emailId}
                          disabled
                          placeholder="Enter your email"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {EMAIL_REQUIRED}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group as={Col} md="12 mt-3">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          type="text"
                          onChange={handelform}
                          name="address"
                          value={regForm?.address}
                          placeholder="Enter your Address"
                          required
                        />
                        <Form.Control.Feedback type="invalid">
                          {requiredError("address")}
                        </Form.Control.Feedback>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        className="text-left"
                        controlId="validationCustomCountry"
                      >
                        <Form.Label>Country</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="country"
                            value={location?.country || regForm?.country}
                            placeholder="Enter your Country"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {requiredError("country")}
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group
                        as={Col}
                        md="6 mt-3"
                        className="text-left"
                        controlId="validationCustomState"
                      >
                        <Form.Label>State</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="state"
                            value={
                              location?.["places"]?.[0]?.state || regForm?.state
                            }
                            placeholder="Enter your State/Province"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {requiredError("state/province")}
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3" className="text-left">
                        <Form.Label>City</Form.Label>
                        <InputGroup hasValidation>
                          <Form.Control
                            type="text"
                            onChange={handelform}
                            name="city"
                            value={
                              location?.["places"]?.[0]?.["place name"] ||
                              regForm?.city
                            }
                            placeholder="Enter your City"
                            required
                          />
                          <Form.Control.Feedback type="invalid">
                            {requiredError("city")}
                          </Form.Control.Feedback>
                        </InputGroup>
                      </Form.Group>
                      <Form.Group as={Col} md="6 mt-3">
                        <Form.Label>Zip/Province Code</Form.Label>
                        <Form.Control
                          type="text"
                          minLength={3}
                          maxLength="5"
                          // #108: usp_InsertUserProfile refuses anything but five digits; saying
                          // so here reports it together with the other fields, not on its own
                          // round trip.
                          pattern="[0-9]{5}"
                          onChange={handelZipCode}
                          name="zipCode"
                          value={regForm?.zipCode}
                          placeholder="Enter your Zip Code"
                          required
                          // SP-11: a failed lookup marks the field invalid, so the form cannot be
                          // saved while country/state/city are still showing the previous address.
                          isInvalid={!!zipError}
                        />
                        {/* SP-11: the lookup has a visible state at last - "looking up" while it
                            runs, and the reason next to the field when it fails. */}
                        {zipLoading && (
                          <Form.Text className="text-muted">
                            Looking up your address&hellip;
                          </Form.Text>
                        )}
                        <Form.Control.Feedback type="invalid">
                          {zipError || ZIP_INVALID}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Row>
                    <button
                      type="button"
                      className="cancel-btn mt-3"
                      onClick={cancelbtn}
                    >
                      Cancel
                    </button>
                    <Button type="submit" className="update-btn-prof">
                      Update
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Card>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
